"use strict";

exports.__esModule = true;
exports.default = void 0;

var _cloneSvg = _interopRequireDefault(require("./clone-svg.js"));

var _requestQueue = require("./request-queue.js");

var _svgCache = _interopRequireDefault(require("./svg-cache.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadSvg = function loadSvg(url, callback) {
  var isLocal = window.location.protocol === 'file:';

  if (_svgCache.default[url] !== undefined) {
    if (_svgCache.default[url] instanceof SVGSVGElement) {
      callback(null, (0, _cloneSvg.default)(_svgCache.default[url]));
      return;
    }

    if (_svgCache.default[url] instanceof Error) {
      callback(_svgCache.default[url]);
      return;
    } // We don't have it in cache yet, but we are loading it, so queue this
    // request.


    (0, _requestQueue.queueRequest)(url, callback);
  } else {
    if (!window.XMLHttpRequest) {
      callback(new Error('Browser does not support XMLHttpRequest'));
      return false;
    } // Seed the cache to indicate we are loading this URL already


    _svgCache.default[url] = {};
    (0, _requestQueue.queueRequest)(url, callback);
    var httpRequest = new XMLHttpRequest();

    httpRequest.onreadystatechange = function () {
      try {
        if (httpRequest.readyState === 4) {
          if (httpRequest.status === 404 || httpRequest.responseXML === null) {
            throw new Error(isLocal ? 'Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver.' : 'Unable to load SVG file: ' + url);
          } // 200 success from server, or 0 when using file:// protocol locally


          if (httpRequest.status === 200 || isLocal && httpRequest.status === 0) {
            if (httpRequest.responseXML instanceof Document) {
              _svgCache.default[url] = httpRequest.responseXML.documentElement;
            } else if (DOMParser && DOMParser instanceof Function) {
              // IE9 doesn't create a responseXML Document object from loaded SVG,
              // and throws a "DOM Exception: HIERARCHY_REQUEST_ERR (3)" error
              // when injected.
              //
              // So, we'll just create our own manually via the DOMParser using
              // the the raw XML responseText.
              //
              // :NOTE: IE8 and older doesn't have DOMParser, but they can't do
              // SVG either, so...
              var xmlDoc;

              try {
                var parser = new DOMParser();
                xmlDoc = parser.parseFromString(httpRequest.responseText, 'text/xml');
              } catch (e) {
                xmlDoc = undefined;
              }

              if (!xmlDoc || xmlDoc.getElementsByTagName('parsererror').length) {
                throw new Error('Unable to parse SVG file: ' + url);
              }

              _svgCache.default[url] = xmlDoc.documentElement;
            }

            (0, _requestQueue.processRequestQueue)(url);
          } else {
            throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
          }
        }
      } catch (error) {
        _svgCache.default[url] = error;
        (0, _requestQueue.processRequestQueue)(url);
      }
    };

    httpRequest.open('GET', url); // Treat and parse the response as XML, even if the
    // server sends us a different mimetype

    if (httpRequest.overrideMimeType) httpRequest.overrideMimeType('text/xml');
    httpRequest.send();
  }
};

var _default = loadSvg;
exports.default = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@tanem/svg-injector/lib/load-svg.js
 ** module id = 1049
 ** module chunks = 0
 **/